import { renderSearchResultsAusschuettungUndThesaurierungsdaten } from "./renderSearchResultsAusschuettungUndThesaurierungsdaten"
import { renderSearchResultsBasisinformationblaetter } from "./renderSearchResultsBasisinformationblaetter"
import { renderQuickSearchElement } from "./renderQuickSearchElement"

window.addEventListener('load', async () => {
  /**
   * @type {HTMLFormElement}
   */


  const searchForm = document.getElementById('ke_search_quicksearch_form')
  if (!searchForm) return;

  searchForm.addEventListener('submit', e => e.preventDefault())
  document.addEventListener('click', () => {
    document.querySelectorAll('.availablefonds-result').forEach(result => result.classList.remove('hasresult'));
  });

  const resultTemplate = searchForm.parentElement.parentElement.parentElement.querySelector('.availablefonds-result ul')

  searchForm?.addEventListener('input', async e => {
    e.preventDefault()

    // TODO: include timer so we can't spam the search and overwork the server

    // the search should have a minmum length of 4 symbols
    // if (e.target?.value?.length <= 3) {
    //   return;
    // }

    const searchInput = searchForm.querySelector('input')

    const sword = searchInput.value

    if (sword === '') {
      return;
    }


    try {
      const response = await fetch(searchForm.action, {
        method: 'POST',
        body: JSON.stringify({
          sword,
        }),
      });
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }

      /**
       * @type {{
       *  content: string,
       *  directory: string,
       *  path: string,
       *  title: string,
       * abstract: string,
       *  hidden_content?: {
       *    ISIN: string,
       *    WKN: string,
       *    clean_title: string
       *  }[]}[]
       */
      const searchResults = await response.json();

      // quick search results
      resultTemplate.textContent = ''
      if (!searchResults.length) {
        const listElement = renderQuickSearchElement("Keine Fonds gefunden!", "")
        resultTemplate.appendChild(listElement)
      }

      if (searchResults.length) {
        switch (searchForm.action.replace(window.location.origin, '')) {
          case "/api/v1/search/ausschuettung-thesaurierung":
            // disabled by LAW2-48. use default ke_search with eID=fonds&function=instant&search=
            return;
            searchResults.forEach(result => {
              // this way we dont have multiple elements with the same ISIN (different years)
              if (resultTemplate.innerHTML.includes(result.hidden_content.ISIN)) return

              const listElement = renderQuickSearchElement(result['hidden_content']['title'], result['hidden_content']['ISIN'])

              resultTemplate.appendChild(listElement)

              listElement.addEventListener('click', e => {
                // no need to search again
                e.preventDefault()

                renderSearchResultsAusschuettungUndThesaurierungsdaten({
                  resultList: searchResults,
                  selectedResult: result,
                  target: searchForm.action.replace(window.location.origin, ''),
                  title: `Ausschüttungs- und Thesaurierungsdaten für ${result['hidden_content']['title']}`,
                })
                // close results
                resultTemplate.parentElement.classList.remove('hasresult')
                searchInput.value = result.hidden_content.title
              })
            })
            break;
          case "/api/v1/search/basisinformationsblaetter":
            // now we're creating the list elements
            searchResults.forEach(result => {
              try {
                // this way we dont have multiple elements with the same ISIN (different years)
                if (resultTemplate.innerHTML.includes(result.hidden_content.ISIN)) return

                const listElement = renderQuickSearchElement(result.hidden_content.clean_title, result.hidden_content.ISIN)

                resultTemplate.appendChild(listElement)

                listElement.addEventListener('click', e => {
                  // no need to search again
                  e.preventDefault()

                  renderSearchResultsBasisinformationblaetter({
                    resultList: searchResults,
                    selectedResult: result,
                    target: searchForm.action.replace(window.location.origin, ''),
                    title: `Kostenstruktur zum Basisinformationsblatt für ${result.hidden_content.clean_title}`,
                  })
                  // close results
                  resultTemplate.parentElement.classList.remove('hasresult')
                  searchInput.value = result.hidden_content.clean_title
                })
              } catch (error) {
                console.warn(error)
              }
            })
            break;

          default:
            console.warn("requested " + searchForm.action.replace(window.location.origin, ''))
            break;
        }

        // we toggle the visibility of the quick search result list
        if (resultTemplate.innerHTML) {
          resultTemplate.parentElement.classList.add('hasresult')
        } else {
          resultTemplate.parentElement.classList.remove('hasresult')
        }
      }
    } catch (error) {
      console.error(error.message);
    }
  })
})










